import templateUrl from './about-us-advisory-committee.html';

export const aboutUsAdvisoryCommitteeComponent = {
	templateUrl,

	bindings: {
		details: '<'
	},

	controller: class AboutUsAdvisoryCommitteeComponent {
		constructor($state, AdvisoryCommitteeService) {
			'ngInject';

			this.$state = $state;
			this.advisoryCommitteeService = AdvisoryCommitteeService;
		}
		
		$onInit() {
			this.details = this.advisoryCommitteeService.getAdvisoryCommitteeDetails(this.details)
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us-advisory-committee/about-us-advisory-committee.component.js